import { BUTTON_S_FIELD } from '../type_name'
import { getVariateTypeCompare } from '../utils'
import { V_TYPES } from '../constants'
import ButtonSv from './button_s_v'
const { arr, fun } = V_TYPES
const default_key = {
    depressed: true,
    small: true
}
export const headerHandler = header => {
    const header_clone = {...header}
    header_clone.align = header_clone.align || 'center'
    return header_clone
}
export default {
    name: BUTTON_S_FIELD,
    props: {
        value: {
            type:[String, Number, Object]
        },
        header: {
            type:[String, Number, Object]
        },
        index: {
            type: Number,
        },
        target: {
            type: Object,
        }
    },
    computed: {
        valueHandle() {
            const { buttons, ...other } = this.header 
            let buttons_clone = null
            // arr
            if (getVariateTypeCompare(buttons, arr)) {
                buttons_clone = buttons
            } 
            if (getVariateTypeCompare(buttons, fun)) {
                buttons_clone = buttons(this.header, this.target)
            }   
            return <ButtonSv
                btns={ buttons_clone }
                other={ other }
                target={this.target}
            />
        }
    },
    methods: {

    },
    render() {
        return <div>
        { this.valueHandle }
        </div> 
    }
}